<template>
  <div>

    <div class="nav">
      <el-radio-group v-model="activeName">
        <el-radio-button v-if="ifFirstShow" class="nav-item" label="first" border>
          <i class="el-icon-date el-icon--left"></i>记录
        </el-radio-button>
        <el-radio-button v-if="ifSecondShow" class="nav-item grayBg" label="second" border>
          <i class="el-icon-setting el-icon--left"></i>设置
        </el-radio-button>
      </el-radio-group>
    </div>

    <div class="content">
      <VisitInfoView v-if="activeName === 'first'" visitType="subscribe"></VisitInfoView>
      <VisitSettingView v-else visitType="subscribe"></VisitSettingView>
    </div>


  </div>
</template>

<script>
import VisitInfoView from './VisitInfoView.vue';
import VisitSettingView from '@/pages/visitSetting/VisitSettingView.vue';

export default {
  components: {
    VisitInfoView, VisitSettingView
  },

  data() {
    return {
      activeName: 'first'
    };
  },

  mounted() {
    this.activeName = this.defaultActiveName
  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },

  computed: {
    defaultActiveName: function () {
      if (this.ifFirstShow) {
        return "first"
      } else {
        return "second"
      }
    },

    ifFirstShow: function () {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "VIEW":
        case "MANAGE":
          return true
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("APPLY_RECORD_SELECT")

        default:
          return false
      }
    },

    ifSecondShow() {
      const group = ["VISITOR_FORM_SELECT", "VISITOR_FORM_MODIFY", "VISITOR_FLOW_SELECT", "VISITOR_FLOW_MODIFY"]
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "VIEW":
        case "MANAGE":
          return true
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return group.some((item) => {
            return this.$store.state.myPermissions.includes(item)
          })
        default:
          return false
      }
    },

  }
}
</script>

<style lang="less" scoped>

.nav {
  //padding-left: 10px;
  //padding-bottom: 10px;
  //background-color: #efefef;

  .nav-item {
    margin-right: 15px;
  }
}

//.grayBg {
//
//}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;

}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}


.content {
  background-color: white;
}
</style>
